<template>
  <component
    :is="
      creative._type
        ? _.kebabCase(creative._type + 'Iframe').replace('-with-outstream', '')
        : ''
    "
    :creative="creative"
  ></component>
</template>

<script>
import OutstreamIframe from "@/components/pages/previews/iframes/outstream.vue";

export default {
  data() {
    return {
      creativeId: this.$route.params.creativeId,
      creative: this.$route.query,
    };
  },
  components: {
    OutstreamIframe,
  },
  mounted() {
    if (this.creative._type !== "outstream") {
      let command = {};

      command.type = "initial";
      window.parent.postMessage(command, "*");
      window.addEventListener("message", this.messageHandler, false);
    }
  },
  methods: {
    messageHandler(e) {
      switch (e.data.type) {
        case "initialCreative":
          this.creative = e.data.creative;
          break;
        default:
          break;
      }
    },
  },
};
</script>
